export class Location {

    private active: boolean;
    private centerInternalId: string;
    private centerName: string;
    private internalId: string;
    private name: string;
    private numeration: string;
    private status: string;
    private iotInternalId: string;

    constructor(active?: boolean, centerInternalId?: string, centerName?: string, internalId?: string, name?: string, numeration?: string, status?: string, iotInternalId?: string) {
        this.active = active;
        this.centerInternalId = centerInternalId;
        this.centerName = centerName;
        this.internalId = internalId;
        this.name = name;
        this.numeration = numeration;
        this.status = status;
        this.iotInternalId = iotInternalId;
    }

    public get Active() {
        return this.active;
    }
    public get CenterInternalId() {
        return this.centerInternalId;
    }
    public get CenterName() {
        return this.centerName;
    }
    public get InternalId() {
        return this.internalId;
    }
    public get Name() {
        return this.name;
    }
    public get Numeration() {
        return this.numeration;
    }
    public get Status() {
        return this.status;
    }
    public get IotInternalId() {
        return this.iotInternalId;
    }
    public set Active(active) {
        this.active = active;
    }
    public set CenterInternalId(centerInternalId) {
        this.centerInternalId = centerInternalId;
    }
    public set CenterName(centerName) {
        this.centerName = centerName;
    }
    public set InternalId(internalId) {
        this.internalId = internalId;
    }
    public set Name(name) {
        this.name = name;
    }
    public set Numeration(numeration) {
        this.numeration = numeration;
    }
    public set Status(status) {
        this.status = status;
    }
    public set IotInternalId(iotInternalId) {
        this.iotInternalId = iotInternalId;
    }
}
